import React, { ReactElement } from 'react';

import { classNames } from '../../common/utils/classNames';

export const TD: React.FC<{ wrap?: boolean }> = ({ wrap, children }): ReactElement => (
  <td className={classNames(wrap && 'text-wrap')} style={wrap ? {} : { overflow: 'initial' }}>
    {children}
  </td>
);
